import throttle from 'lodash.throttle';
import { replace } from 'connected-react-router';

import onIframeComunication from './utils/iframeCommunication';
import { colorPlaceholderText } from './utils/byobUtils';

export function HigherOrderReducer(reducers) {
    return function(state = {}, action) {
        const { payload } = action;
        switch (action.type) {
            case 'REPLACE_WHOLE_STATE': {
                const newState = {
                    ...state,
                    widget: {
                        ...state.widget,
                        isSponsored: true,
                        sponsoredText: payload.widgetData.sponsoredText,
                        cards: [
                            {
                                ...state.widget.cards[0],
                                heading: payload.cardData?.heading ||
                                            state.widget.cards[0].heading,
                                subHeading: undefined,
                            }
                        ],
                        activeAction: {
                            ...state.widget.activeAction,
                            ...payload.activeAction
                        }
                    }
                };

                if (payload.isFinalStep && payload.widgetData.cards.length > 1){
                    const currentActionData =
                        payload.widgetData.cards[payload.currentAction].actions[0]
                    if (payload.currentAction === 0) {
                        currentActionData.endCardPictureId = null;
                        currentActionData.recipientPictureIds = [];
                        currentActionData.representativeSearch = null;
                    }
                    newState.widget.activeAction = {
                        ...state.widget.activeAction,
                        ...currentActionData
                    }
                }

                const actionState = payload.actionState;
                if (actionState?.data) newState[actionState.key] = actionState.data;

                return newState;
            }
            default:
                return reducers(state, action);
        }
    };
}

export function enablePreviewMode(store){
    const replaceStateThrottled = throttle((previewData) => {
        store.dispatch({
            type: 'REPLACE_WHOLE_STATE',
            payload: previewData
        });
        if (previewData.route) store.dispatch(replace(previewData.route));
        if (previewData.activeAction?.type === "email"){
            const messageBox =  document.querySelector('textarea[name="message"]');
            if (messageBox) messageBox.value = previewData.activeAction.text;
            const label =  document.querySelector('label[name="message"]');
            if (label) label.style.display = messageBox?.value ? 'none' : 'initial';
        }
        colorPlaceholderText();
        setTimeout(colorPlaceholderText,500);
    }, 500);

    onIframeComunication(e => {
        if (e.data.replaceRootLevelState){
            replaceStateThrottled(e.data.byobPreviewData);
        }
    });
}
